import { computed, makeObservable } from 'mobx';
import { IDeviceDetailsConstructorOptions } from './device-detail-entry-store';
import { DeviceFileTransferExecutionResultDto } from 'dto/file-transfer.dto';
import { HistoricalListingStore } from './historical-listing.store';

export class DeviceFileTransferExecutionsHistoryStore extends HistoricalListingStore<DeviceFileTransferExecutionResultDto> {
    constructor(options: IDeviceDetailsConstructorOptions) {
        super('file transfer executions history', options);
        makeObservable(this);
    }

    /** ************************************
     * Override functions
     **************************************/
    protected async getHistoricalEntries(accountId: number, uid: string, filterByDateFrom?: string, filterByDateTo?: string): Promise<DeviceFileTransferExecutionResultDto[]> {
        return this._devicesStore.getHistoricalOfFileTransferExecutionResult(accountId, uid, filterByDateFrom, filterByDateTo);
    }

    @computed
    public get fileTransferExecutions(): DeviceFileTransferExecutionResultDto[] {
        return this.entities;
    }
}
